/**
 * W2-S S1: a price moved by more than half of what it was, up or down, is
 * flagged in a bulk preview, and the apply then asks once more. Up by more
 * than half: after > 1.5 × before; down by more than half: after < 0.5 ×
 * before. In integers (CLAUDE.md: no floats): 2 × after against 3 × before
 * and against before. Exactly half either way is not flagged. A price set
 * where there was none, or taken away, is no move of a price, and not flagged.
 */
export function movesByMoreThanHalf(before: number | null, after: number | null): boolean {
  if (before === null || after === null || before <= 0) return false
  return 2 * after > 3 * before || 2 * after < before
}

/** The changes of a preview whose price moves by more than half. */
export function bigMoves<
  T extends { before: { priceCents: number | null }; after: { priceCents: number | null } },
>(changes: readonly T[]): T[] {
  return changes.filter((change) =>
    movesByMoreThanHalf(change.before.priceCents, change.after.priceCents),
  )
}
